import request from './index';

export function addSolution(data) {
  return request.post('officialPageSolution/add', data);
}

export function updateSolution(data) {
  return request.post('officialPageSolution/update', data);
}

export function deleteSolution(id) {
  return request.post('officialPageSolution/delete', { id });
}

export function getSolutionDetail(id) {
  return request.get('officialPageSolution/detail', { params: { id } });
}

export function getSolutionPage(params) {
  return request.get('officialPageSolution/page', { params });
}

export function getSolutionList(params) {
  return request.get('officialPageSolution/list', { params });
}
